import BaseModal from "../BaseModal/BaseModal";
import {useMemberShipModal} from "../../redux/Reducers/buy-membership-slice";
import {DAILY_PRACTICE_LIMIT} from "../../settings/settings";
import {useNavigate} from "react-router-dom";
import BuyMemberShip from "../../components/utils/buy-member-ship";

export default function BuyMembershipModal({className, ...props}) {
    const [isOpen, actions] = useMemberShipModal();
    return (
        <BaseModal title={"Upgrade to VIP"} innerClassName={` ${className} lg:w-1/2`}
                   isBoxOpen={isOpen}
                   setIsBoxOpen={actions.set}
        >
            <BuyMemberShip onClickBuy={()=>actions.close()} />
        </BaseModal>

    )
}